export default __webpack_public_path__ + "static/media/mons3.cb54bf7d.jpg";